var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacturacion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.653 415.531a1.53 1.53 0 00-1.141-.531h-7.905c-.884 0-1.607.81-1.607 1.8v14.4c0 .99.715 1.8 1.6 1.8h11.793c.884 0 1.607-.81 1.607-1.8v-10.053a1.88 1.88 0 00-.474-1.269l-3.873-4.347zm.061 13.869h-6.428c-.59 0-1.072-.405-1.072-.9s.482-.9 1.072-.9h6.428c.59 0 1.072.405 1.072.9s-.482.9-1.072.9zm0-3.6h-6.428c-.59 0-1.072-.405-1.072-.9s.482-.9 1.072-.9h6.428c.59 0 1.072.405 1.072.9s-.482.9-1.072.9zm-1.339-5.4v-4.05l4.42 4.95h-3.616c-.442 0-.804-.405-.804-.9z",
    id: "a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fillRule: "currentColor",
    xlinkHref: "#a",
    transform: "translate(-10 -415)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacturacion);
export default __webpack_public_path__ + "static/media/icon_facturacion.1455f6c595a658c81302cecce86cfbfe.svg";
export { ForwardRef as ReactComponent };